"use strict";

import utils from './_utils';

(function () {

    const tinymces = $('.tinymce');

    if (tinymces.length) {
        window.tinymce.init({
            selector: '.tinymce',
            height: '50vh',
            menubar: false,
            skin: utils.settings.tinymce.theme,
            content_style: `.mce-content-body { color: ${utils.grays.black} }`,
            mobile: {
                theme: 'mobile',
                toolbar: ['undo', 'bold'],
            },
            statusbar: false,
            plugins: 'link,image,lists,table,media,code',
            toolbar:
                'styleselect | fontsizeselect forecolor backcolor | bold italic link bullist numlist image undo redo code',
        });
    }

    $(document).on('focusin', function(e) {
        if ($(e.target).closest(".tox-dialog").length) {
            e.stopImmediatePropagation();
        }
    });
})();
